var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5257 2.14935C13.8205 2.33156 14 2.65342 14 3V6.46482L19.5547 10.168C19.8329 10.3534 20 10.6656 20 11V20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20H4V7C4 6.62123 4.214 6.27497 4.55279 6.10557L12.5528 2.10557C12.8628 1.95058 13.2309 1.96714 13.5257 2.14935ZM6 20H12V7.01368C11.9999 7.00395 11.9999 6.99422 12 6.98449V4.61803L6 7.61803V20ZM14 8.86852V20H18V11.5352L14 8.86852Z",
  fill: "#E2E8EE"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9C9.55228 9 10 9.44772 10 10V10.01C10 10.5623 9.55228 11.01 9 11.01C8.44772 11.01 8 10.5623 8 10.01V10C8 9.44772 8.44772 9 9 9Z",
  fill: "#E2E8EE"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 12C9.55228 12 10 12.4477 10 13V13.01C10 13.5623 9.55228 14.01 9 14.01C8.44772 14.01 8 13.5623 8 13.01V13C8 12.4477 8.44772 12 9 12Z",
  fill: "#E2E8EE"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 15C9.55228 15 10 15.4477 10 16V16.01C10 16.5623 9.55228 17.01 9 17.01C8.44772 17.01 8 16.5623 8 16.01V16C8 15.4477 8.44772 15 9 15Z",
  fill: "#E2E8EE"
})));
export default __webpack_public_path__ + "static/media/accounts.9f2b2e67.svg";
export { SvgComponent as ReactComponent };